"use client";

import React from "react";
import { GameCard } from "modules/cards/model/card";
import { CardImageText } from "modules/common/components/CardDetailsDialog/CardImageText";
import { ResponsiveCardSizing } from "utils/styles";
import { getCardHeroTransitionName } from "utils/utils";
import { useCardFinishState } from "modules/cards/hooks/useCardFinishState";
import { useSets } from "modules/common/hooks/useSets";
import { useCardDetails } from "modules/cards/hooks/useCardDetails";
import {
  usePricingRequest,
  withoutPrice,
} from "modules/common/hooks/usePricingRequest";

interface ClientCardImageProps {
  card: GameCard;
}

export default function ClientCardImage({ card }: ClientCardImageProps) {
  const { cacheKey, shouldMaskCachedPricing } = usePricingRequest();
  const { card: pricedCard } = useCardDetails({
    setCode: card.setCode,
    cardNumber: card.number,
    cardId: card.id,
    printingKey: card.printing?.key,
    game: card.game,
  });
  const displayedCard =
    pricedCard ??
    (cacheKey || shouldMaskCachedPricing ? withoutPrice(card) : card);
  const { selectedFinish } = useCardFinishState({
    card: displayedCard,
  });
  const sets = useSets();

  return (
    <figure className="sm:max-w-(--breakpoint-sm) mx-auto flex max-w-sm flex-col justify-center md:max-w-none md:justify-start md:py-4">
      <CardImageText
        card={displayedCard}
        isDialog={false}
        sizing={ResponsiveCardSizing}
        finish={selectedFinish}
        isPriority
        viewTransitionName={getCardHeroTransitionName(card)}
      />
      <figcaption className="sr-only">
        {displayedCard.name} from{" "}
        {displayedCard.setCode ||
          sets.getSetName(displayedCard.setCode, displayedCard.game)}
      </figcaption>
    </figure>
  );
}
